export class Intelli360CodeLoginInfo {

    constructor(code: string, intelliDashRefreshToken: string) {
        this.refreshToken = intelliDashRefreshToken;
        this.intelli360Code = code;
    }

    grantType = 'intelli360_code';
    refreshToken: string;
    intelli360Code: string;

}
